import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';
import { Observable } from 'rxjs';
import { EstadoRouteService } from 'src/app/services/estado-route.service';
import { UsuarioEnSesionService } from 'src/app/services/usuario-en-sesion.service';
import { UsuarioSesionDTO } from 'src/app/models/dtos/usuario-sesion-dto';

@Component({
  selector: 'root',
  templateUrl: './root.component.html',
  styleUrls: ['./root.component.scss']
})
export class RootComponent implements OnInit {
  public loaderScreen$: Observable<{ activo: boolean, mensaje: string }>;
  public constructor(
    public loaderScreenService: LoaderService,
    private estadoRouteService: EstadoRouteService,
  ) {

  }
  ngOnInit(): void {
    this.loaderScreen$ = this.loaderScreenService.obtenerObsLoaderScreen();
  }
}
